import Gmap2PointLinkCreateUI from './components/Gmap2PointLinkCreateUI/App';

document.addEventListener('DOMContentLoaded', () => {
  const outlineMapImages = document.querySelectorAll('.access__mapImage img');
  const zoomBackground = document.querySelector('.access__outlineMapZoom');
  const zoomImg = document.querySelector('.access__outlineMapZoom img');
  const expansionButtons = document.querySelectorAll('.access__mapExpansionButton');

  // 拡大表示の背景をクリックしたら閉じる
  const downScale = () => {
    zoomBackground.style.display = 'none';
    zoomImg.classList.remove('access__outlineMapZoom--scale');
  };

  // ボタンのクリックイベントを設定
  if (expansionButtons) {
    expansionButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        if (outlineMapImages[index]) {
          // 対応する地図の画像を取得して拡大表示
          const imgSrc = outlineMapImages[index].getAttribute('src');
          zoomImg.setAttribute('src', imgSrc);
          zoomBackground.style.display = 'flex';
          zoomImg.classList.add('access__outlineMapZoom--scale');
        }
      });
    });
  }

  if (zoomBackground) {
    zoomBackground.addEventListener('click', downScale);
  }

  // ---------------------------------
  // routePage
  // ---------------------------------
  if (document.querySelector('.js-access-gmap-2point-link-create-ui')) {
    new Gmap2PointLinkCreateUI({
      appSelector: '.js-access-gmap-2point-link-create-ui',
      locale: document.querySelector('.js-access-gmap-2point-link-create-ui').dataset.locale,
    });
  }
});
